<template>
  <CCard>
    <CCardHeader>
      <strong>Edit Topic</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CInput
            label="Name"
            placeholder="Enter topic name"
            v-model="topic.name"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <div class="form-group">
            <label>Category</label>
            <select class="form-control" v-model="topic.category_id" @change="changeCategory">
                <option v-for="cat in categories" :value="cat.id" :key="cat.id" :class="{ 'font-weight-bold' : cat.parent==''}">
                {{ cat.name }}
              </option>
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea
            label="Description"
            placeholder="Enter topic description"
            v-model="topic.description"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <img :src="img_url" style="width: 200px; height: 200px" />
          <CInputFile
            label="Image thumbnail"
            vertical
            ref="file"
            type="file"
            id="file"
            @change="onImageChange"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
          <label class="text-danger"
            >(Image Size should be (360 X 360) and less than 1 MB)</label
          >
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInput
            label="Weight"
            placeholder="Enter Weight"
            v-model="topic.weight"
          />
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Update Topic
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
const ROOT_URL = process.env.VUE_APP_ROOT_URL;
export default {
  name: "TopicEdit",
  data() {
    return {
      topic: {},
      img_url: "",
      categories: [],
    };
  },
  created() {
    this.getTopic();
    
  },
  methods: {
    getTopic() {
      this.$axios
        .get(`${ADMIN_URL}/topics/${this.$route.params.id}`)
        .then((response) => {
          console.log(response.data);
          this.topic = response.data.topic;
          this.img_url = ROOT_URL + "/" + this.topic.image;
          this.getCategories();
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    getCategories() {
      this.$axios
        .get(`${ADMIN_URL}/categories`)
        .then((response) => {
          console.log("categories, response === ", response.data);
          this.categories = response.data.category_list
          this.changeCategory();
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    changeCategory() {
      this.topic.category = this.categories.find((e) => {
        return this.topic.category_id == e.id;
      });
      this.topic.subcategory_id = this.topic.category_id
    },
    onImageChange(e) {
      const file = e[0];
      if (file === undefined) {
        return;
      }
      this.topic.image = file;
      this.img_url = URL.createObjectURL(file);
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("name", this.topic.name);
      formData.append("description", this.topic.description);
      if(this.topic.category.subcategories.length)
      {
        formData.append("category_id", this.topic.subcategory_id);
      }
      else
      {
        formData.append("category_id", this.topic.category_id);
      }
      
      formData.append("image", this.topic.image);
      formData.append("weight", this.topic.weight);
      formData.append("_method", "put");

      this.$axios
        .post(`${ADMIN_URL}/topics/${this.$route.params.id}`, formData, config)
        .then((response) => {
          console.log("Success", response);
          currentObj.success = response.data.success;
          console.log(response.data);
          this.$swal("Success", response.data.message, "success");
          window.location.reload();
        })
        .catch((error) => {
          console.log("Error  ... ", error.response);
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
    },
  },
};
</script>

<style scoped>
</style>
